'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M112 212.8L112 464l80 0 0-168 0-24 24 0 144 0 24 0 0 24 0 168 80 0 0-251.2L288 63.5 112 212.8z', 'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5 64 488l0 24 24 0 400 0 24 0 0-24 0-234.5 24.5 20.8 31.1-36.6L512 190.6l0-6.6 0-96 0-24-48 0 0 24 0 61.9L303.5 13.7zM464 212.8L464 464l-80 0 0-168 0-24-24 0-144 0-24 0 0 24 0 168-80 0 0-251.2L288 63.5 464 212.8zM336 320l0 144-96 0 0-144 96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;